import isDeepEqual from 'fast-deep-equal';
import { IAppStore } from '../IAppStore';

const keysToDestructure = [
  'location',
  'activeTool',
  'activeView',
  'activeFlyin',
  'activeFlyinView',
  'flyinWidth',
  'toolbar',
  'toolDialogWidth',
  'viewCollapse',
  'currentTopicLayerId',
  'mouseLocation',
  'hoveredFeatureId',
  'previewLayer',
  'drawSettings',
  'newAddedTopicLayer',
  'notifications',
  'layoutTitle',
  'layoutSubTitle',
  'printLegend',
  'printScale',
  'layoutId',
  'orientation',
  'formatValue',
  'angle',
  'printMapOnly',
  'printedItems',
  'showPrintedItems',
  'mapExtent',
  'activeDrawTool',
  'isDrawActive',
  'displayDrawInfoBox',
  'selectedFeatureId',
  'displayResetNotification',
  'isLoggedIn',
  'defaultResultProperties',
  'showidentifyOverlay',
  'showLegend',
  'identifyLegend',
  'identifyCoordinate',
  'landownerEigentuemer',
  'landownerNavigation',
  'errorLayers',
  'attributeSearch',
  'currentAttributeSearchTopicId',
  'loadingLayers',
  'enabledIdentify',
  'displayStartUpMessage',
] as const;

const removeKeys = (state: IAppStore) => {
  const { ...rest } = state;
  keysToDestructure.forEach((key) => {
    delete rest[key];
  });

  return rest;
};

const appStoreEquality = (pastState: IAppStore, currentState: IAppStore) => {
  const restPastState = removeKeys(pastState);
  const restCurrentState = removeKeys(currentState);
  return isDeepEqual(restPastState, restCurrentState);
};

export default appStoreEquality;
